import { render } from "./AccessRequestDetails.vue?vue&type=template&id=1648b2d2"
import script from "./AccessRequestDetails.vue?vue&type=script&lang=js"
export * from "./AccessRequestDetails.vue?vue&type=script&lang=js"

import "./AccessRequestDetails.vue?vue&type=style&index=0&id=1648b2d2&setup=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__